import { render, staticRenderFns } from "./vxe.vue?vue&type=template&id=0930598b&scoped=true"
import script from "./vxe.vue?vue&type=script&lang=js"
export * from "./vxe.vue?vue&type=script&lang=js"
import style0 from "./vxe.vue?vue&type=style&index=0&id=0930598b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930598b",
  null
  
)

export default component.exports